module.exports = __webpack_public_path__ + "static/media/holycross.9c5f94e2.webp";